import './WelcomeTour.scss';

import React, { FC, useContext } from 'react';
import { GlobalTourContext } from 'components/GlobalTourContext/GlobalTourContext';
import NavHeading, { NavHeadingProps } from 'components/NavHeading/NavHeading';
import { NavHeadings } from 'constants/Constants';
import { ArticleGenerationGuideKey } from 'data/intros/ArticleGen.Guide';
import { TeamEfficiencyGuideKey } from 'data/intros/TeamEfficiency.Guide';
import { TopicAuthorityGuideKey } from 'data/intros/TopicAuthority.Guide';
import { Button, Card, Col, Figure, Row } from 'react-bootstrap';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface WelcomeTourProps { }

const WelcomeTour: FC<WelcomeTourProps> = () => {
  const tour = useContext(GlobalTourContext)!;

  const heading: NavHeadingProps = {
    title: 'Welcome to BlabberJax — Turn Ideas Into Spellbinding Content!',
    ...NavHeadings.Welcome,
  };

  return (
    <div className="welcome-tour">
      <div style={{ textAlign: 'center', margin: '2em 0' }}>
        <NavHeading {...heading} />
      </div>
      <Row>
        <Col sm={5} md={3} className='shadow p-3 mb-5 bg-white rounded-20 welcome-bubble'>
          <Figure>
            <Figure.Image
              width={300}
              style={{ margin: '0 auto', textAlign: 'center' }}
              alt="Whizzandra Blogspark"
              src="/wizzandra-raw-image-welcome_v2.png"
              rounded
            />
            <Figure.Caption style={{ textAlign: 'center' }} className="text-light">
              Whizzandra Blogspark of Contentia
            </Figure.Caption>
          </Figure>
          <h4>
            <strong>Greetings marketier, I&#39;m your onboarding wizard!</strong>
          </h4>
          <p>
            Click on my icon in the top right of the screen to summon me at any time. <i className='bi bi-magic' /> <br />
          </p>
          <Button
            variant='outline-light'
            href='https://www.blabberjax.com/about-whizzandra-blogspark/'
            target='_blank'
            rel='noreferrer'>
            Meet your wizard guide
          </Button>

        </Col>
        <Col className='pl-1'>
          <div className='row gx-2 help-guides'>
            <Card as={Col} lg={4} md={6} style={{ padding: 0, marginBottom: '.5em' }}>
              <Button variant="link" className='p-0' onClick={() => tour.navigateToNextStage('/documents/edit/new', ArticleGenerationGuideKey, 1)}>
                <Card.Img variant="top" src="/first-blog-help-v2.png" />
              </Button>
              <Card.Body>
                <Card.Title>The Spark of the First Conjure</Card.Title>
                <div className='card-text'>
                  <p>Write brilliant, SEO-optimized articles — instantly.</p>
                </div>
                <Button
                  onClick={() => tour.navigateToNextStage('/documents/edit/new', ArticleGenerationGuideKey, 1)}
                  className='button-bottom'
                  title="First Conjure"
                >
                  Content Creation tour
                </Button>
              </Card.Body>
            </Card>

            <Card as={Col} lg={4} md={6} style={{ padding: 0, marginBottom: '.5em' }}>
              <Button variant="link" className='p-0' onClick={() => tour.navigateToNextStage('/documents/edit/new', TeamEfficiencyGuideKey, 1)}>
                <Card.Img variant="top" src="/workflow-help.png" />
              </Button>
              <Card.Body>
                <Card.Title>The Art of Flowmancy</Card.Title>
                <div className='card-text'>
                  <p>Automate content approvals and teamwork like magic.</p>
                </div>
                <Button
                  onClick={() => tour.navigateToNextStage('/documents/edit/new', TeamEfficiencyGuideKey, 1)}
                  className='button-bottom'
                  title="Flowmancy"
                >
                  Workflow tour
                </Button>
              </Card.Body>
            </Card>

            <Card as={Col} lg={4} md={6} style={{ padding: 0, marginBottom: '.5em' }}>
              <Button variant="link" className='p-0' onClick={() => tour.navigateToNextStage('/account', TopicAuthorityGuideKey, 1)}>
                <Card.Img variant="top" src="/topic-authority-help-v2.png" />
              </Button>
              <Card.Body>
                <Card.Title>The Runes of Authority</Card.Title>
                <div className='card-text'>
                  <p>Map your content universe to master topic authority.</p>
                </div>
                <Button
                  onClick={() => tour.navigateToNextStage('/account', TopicAuthorityGuideKey, 1)}
                  className='button-bottom'
                  title="Top Authority"
                >
                  Topic Authority tour
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default WelcomeTour;
